/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseSubmissionReportData } from './genericApiResponseSubmissionReportData';
import type { GenericApiResponseSubmissionReportMessage } from './genericApiResponseSubmissionReportMessage';
import type { GenericApiResponseSubmissionReportPagination } from './genericApiResponseSubmissionReportPagination';
import type { GenericApiResponseSubmissionReportError } from './genericApiResponseSubmissionReportError';

export interface GenericApiResponseSubmissionReport {
  data?: GenericApiResponseSubmissionReportData;
  message?: GenericApiResponseSubmissionReportMessage;
  pagination?: GenericApiResponseSubmissionReportPagination;
  error?: GenericApiResponseSubmissionReportError;
  statusCode?: number;
}
